<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" >
                <div style="display:flex;justify-content:center;align-items:center;width:100%;height:100%;color:white;" @scroll.prevent.stop>
                    <h1>現在処理中です、</h1>
                    <h1>しばらくお待ちください。</h1>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        computed: {
            isQuestionMode: function () {
                return this.isQuest === "true";
            },

            realWidth: function() {
                var width = 0;
                if(this.width) {
                    //console.log("width", this.width);
                    width = Number(this.width)
                } else {
                    width = 500;
                }

                //console.log(width);
                return width;
            }
        },

        props: {
            isQuest: String,
            width: String,
        }
    }
</script>
<style scoped lang="scss">
    .modal-mask {
        position: fixed;
        z-index: 99998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
        h1{
            font-size:3em;
        }
    }

    .modal-container {
        width: 500px;
        max-width: calc(100vw - 60px);
        box-sizing: border-box;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;


    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;

        /*max-height:600px;
        overflow-y:scroll;*/
    }

    .modal-default-button {
        /*float: right;*/
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    @media screen and (max-width: 767px) {
    .modal-wrapper {
        background: none !important;
        div{
            display: block !important;
            text-align: center;
            h1{
                font-size:2em;
            }
        }
    }
    }
</style>